/**
 * Error, that should not be tracked, handled in any scope
 */
export class SilentError extends Error {
    constructor(...args) {
        super(...args);
        this.name = 'SilentError';
    }
}
